/* ==========================================================================
   Meridian - cart drawer
   Real Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js).
   Drawer open/close + line qty/remove + live re-render, plus the flash
   toast and header/drawer cart-count sync. Any add-to-cart control on the
   site (formula grid, PDP, stack configurator) dispatches a
   'meridian:add-to-cart' CustomEvent with detail { items: [{id, quantity}], flashText }
   rather than posting a form directly, so every add goes through one path.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-cart-scrim]');
  var body = document.querySelector('[data-cart-body]');
  if (!drawer) return;

  function moneyFormat(cents) {
    // Uses Shopify.money_format if the theme editor / storefront has set it; falls back to £.
    var format = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function setCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderLine(item) {
    var accentColour = (item.properties && item.properties._accent_colour) || '#0E0F0B';
    var imageStyle = item.image ? "background-image:url('" + item.image + "');" : '';
    var line = document.createElement('div');
    line.className = 'm-cart-line';
    line.setAttribute('data-cart-line', '');
    line.setAttribute('data-line-key', item.key);
    line.innerHTML =
      '<div class="m-cart-line__swatch" style="background-color:' + accentColour + ';' + imageStyle + '"></div>' +
      '<div class="m-cart-line__info">' +
        '<span class="m-cart-line__name">' + item.product_title + '</span>' +
        '<span class="m-cart-line__qty">Qty ' +
          '<button type="button" data-cart-qty-decrease aria-label="Decrease quantity">−</button>' +
          '<span data-cart-qty-value>' + item.quantity + '</span>' +
          '<button type="button" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
        '</span>' +
        '<button type="button" class="m-cart-line__remove" data-cart-remove>Remove</button>' +
      '</div>' +
      '<span class="m-cart-line__total" data-cart-line-total>' + moneyFormat(item.final_line_price) + '</span>';
    return line;
  }

  function renderCart(cart) {
    setCounts(cart.item_count);

    body.innerHTML = '';
    if (cart.item_count === 0) {
      var empty = document.createElement('div');
      empty.className = 'm-cart-drawer__empty';
      empty.setAttribute('data-cart-empty', '');
      empty.textContent = 'Cart is empty';
      body.appendChild(empty);
    } else {
      cart.items.forEach(function (item) {
        body.appendChild(renderLine(item));
      });
    }

    var savingEl = document.querySelector('[data-cart-saving]');
    var savingVal = document.querySelector('[data-cart-saving-value]');
    if (savingEl) {
      if (cart.total_discount > 0) {
        savingEl.removeAttribute('hidden');
        if (savingVal) savingVal.textContent = '−' + moneyFormat(cart.total_discount);
      } else {
        savingEl.setAttribute('hidden', '');
      }
    }

    var nudgeEl = document.querySelector('[data-cart-nudge]');
    if (nudgeEl) {
      var nudgeText = '';
      var hasSupply = false;
      var eligCount = (cart.items || []).reduce(function (n, it) {
        var sup = (it.options_with_values || []).some(function (o) { return o.name === 'Supply'; });
        if (sup) hasSupply = true;
        return n + (sup ? 0 : it.quantity);
      }, 0);
      var nudgeSuffix = hasSupply ? ' (supply packs excluded)' : '';
      if (cart.item_count > 0 && eligCount < 3) {
        var need3 = 3 - eligCount;
        nudgeText = 'Add ' + need3 + ' more item' + (need3 > 1 ? 's' : '') + ' to save 10%' + nudgeSuffix;
      } else if (eligCount >= 3 && eligCount < 5) {
        var need5 = 5 - eligCount;
        nudgeText = 'Add ' + need5 + ' more item' + (need5 > 1 ? 's' : '') + ' to save 15%' + nudgeSuffix;
      }
      if (nudgeText) {
        nudgeEl.textContent = nudgeText;
        nudgeEl.removeAttribute('hidden');
      } else {
        nudgeEl.setAttribute('hidden', '');
      }
    }

    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = moneyFormat(cart.total_price);

    var checkoutBtn = document.querySelector('.m-cart-drawer__checkout');
    if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;

    document.dispatchEvent(new CustomEvent('meridian:cart-updated', { detail: { cart: cart } }));
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addToCart(items, flashText) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart);
        if (window.Meridian && window.Meridian.showFlash) {
          window.Meridian.showFlash(flashText || 'Added to cart', cart.item_count);
        }
        openDrawer();
        return cart;
      })
      .catch(function (err) {
        var message = (err && err.description) || 'Could not add to cart';
        if (window.Meridian && window.Meridian.showFlash) window.Meridian.showFlash(message);
        throw err;
      });
  }

  document.addEventListener('meridian:add-to-cart', function (e) {
    var detail = e.detail || {};
    if (!detail.items || !detail.items.length) return;
    addToCart(detail.items, detail.flashText);
  });

  // Quantity / remove controls inside the drawer
  body.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');

    if (e.target.closest('[data-cart-remove]')) {
      changeLine(key, 0);
    } else if (e.target.closest('[data-cart-qty-increase]')) {
      var valEl = line.querySelector('[data-cart-qty-value]');
      changeLine(key, parseInt(valEl.textContent, 10) + 1);
    } else if (e.target.closest('[data-cart-qty-decrease]')) {
      var valEl2 = line.querySelector('[data-cart-qty-value]');
      changeLine(key, Math.max(0, parseInt(valEl2.textContent, 10) - 1));
    }
  });

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  // Sync counts on load
  fetchCart().then(function (cart) {
    setCounts(cart.item_count);
  });

  window.Meridian = window.Meridian || {};
  window.Meridian.cart = { open: openDrawer, close: closeDrawer, addToCart: addToCart, fetchCart: fetchCart };
})();
